import { db } from '../../common/config/Firebase';

/**
 * Deletes a vacation period by its ID
 * @param {string} vacationId - Vacation document ID
 * @returns {Promise<void>}
 */
export const deleteEmployeeVacationUseCase = async (vacationId) => {
    try {
        await db.collection('employeeVacations').doc(vacationId).delete();
        console.log(`Vacation deleted: ${vacationId}`);
    } catch (error) {
        console.error('Error deleting vacation:', error);
        throw error;
    }
};
